var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.147,
    height: 8.083,
    viewBox: "0 0 14.147 8.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chevron-down-solid",
    d: "M38.285,167.712a1.012,1.012,0,0,0,1.43,0l6.061-6.061a1.011,1.011,0,1,0-1.43-1.43L39,165.569l-5.348-5.345a1.011,1.011,0,0,0-1.43,1.43l6.061,6.061Z",
    transform: "translate(-31.925 -159.925)",
    fill: "#fc5400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropColor);
export default __webpack_public_path__ + "static/media/drop_color.a6449c6bc0c60ec0a2c0d6325029ff2e.svg";
export { ForwardRef as ReactComponent };